import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from 'src/redux/index'
import { getUserContestAction } from 'src/redux/actions/xcontest'
import { MyContestWrapper } from './style'
// import { ContestCard, ContestFlex } from '../style'
import {
  ContestCard,
  ContestFlex,
  ContestCardHeader,
  ContestCardBody,
  ContestImg,
} from '../style'
import { Link, useLocation } from 'react-router-dom'
import { addNairaSign } from 'src/utils/addNairaSign'
import { LinkArrowSvg } from 'src/assets'
import { ContestUsersSvg } from 'src/assets'

const MyContest = () => {
  const userContest = useTypedSelector((state) => state.xcontest.userContests)
  let location = useLocation()

  console.log(userContest)

  return (
    <ContestFlex>
      {userContest?.map((item: any) => {
        return (
          <Link
            to={`/joined-contest/${item.contest_id}`}
            key={item.contest_id}
            state={{ backgroundLocation: location }}
            className="contest_card_link"
          >
            <ContestCard key={item.contest_id}>
              <ContestCardHeader>
                <ContestImg src={item.image_url} alt="" />
              </ContestCardHeader>
              <ContestCardBody>
                <div className="name_img">
                  <h3>{item.contest_name}</h3>
                  {/* <img src={ContestUsersSvg} alt="" /> */}
                </div>
                <p>
                  <span>{addNairaSign(item.amount_to_save)}</span>
                  every month
                </p>
                <p>
                  <span>{addNairaSign(item.reward)}</span> reward
                </p>
                <div className="link_wrapper">
                  <Link to={`/xcontest/${item.id}`} className="contest_link">
                    Contest detail
                    <img src={LinkArrowSvg} alt="" />
                  </Link>
                </div>
              </ContestCardBody>
            </ContestCard>
          </Link>
        )
      })}
    </ContestFlex>
  )
}

export default MyContest
